import { NgModule } from '@angular/core';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { UiGeneralModule } from '../ui-general/ui-general.module';
import { PipesModule } from '../core/pipes/pipes.module';
import { BrowserModule } from '@angular/platform-browser';
import { WeeklyScheduleComponent } from './components/weekly-schedule/weekly-schedule.component';
import { MyConferenceInfoDialogComponent } from './components/my-conference-info-dialog/my-conference-info-dialog.component';
import { RoomConferenceInfoDialogComponent } from './components/room-conference-info-dialog/room-conference-info-dialog.component';
import { MySchedulePageComponent, RoomSchedulePageComponent } from './pages';
import { MatDialogModule, MatTabsModule, MatStepperModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClusterSchedulePageComponent, MyClusterSchedulePageComponent } from './pages';
import { ClusterScheduleComponent } from './components/cluster-schedule/cluster-schedule.component';
import { MapModule } from '../map/map.module';

@NgModule({
    declarations: [
        WeeklyScheduleComponent,
        ClusterScheduleComponent,
        MyConferenceInfoDialogComponent,
        RoomConferenceInfoDialogComponent,
        MySchedulePageComponent,
        RoomSchedulePageComponent,
        ClusterSchedulePageComponent,
        MyClusterSchedulePageComponent
    ],
    imports: [
        MatDialogModule,
        MatTabsModule,
        BrowserAnimationsModule,
        AngularFontAwesomeModule,
        UiGeneralModule,
        PipesModule,
        BrowserModule,
        MapModule
    ],
    exports: [
        MySchedulePageComponent,
        RoomSchedulePageComponent,
        ClusterSchedulePageComponent,
        MyClusterSchedulePageComponent
    ],
    entryComponents: [
        MyConferenceInfoDialogComponent,
        RoomConferenceInfoDialogComponent,
        WeeklyScheduleComponent,
        MySchedulePageComponent,
        RoomSchedulePageComponent
    ],
  })
  export class ScheduleModule { }



// WEBPACK FOOTER //
// ./src/app/schedule/schedule.module.ts